import { is } from 'vee-validate/dist/rules';

export default {
  ...is,
  computesRequired: true,
  message: 'Please check and confirm you agree with each statement above',
};
